import XLSXStyle from "xlsx-js-style";

const COLOR_MARCA = "00BFD6";
const RENGLONES_EN_BLANCO = 30;

const COLUMNAS = [
  { titulo: "Origen", clave: "origen", ancho: 24 },
  { titulo: "Motivo", clave: "motivo", ancho: 45 },
  { titulo: "Código", clave: "codigo", ancho: 12 },
];

const bordeFino = { style: "thin", color: { rgb: "BFBFBF" } };
const bordes = { top: bordeFino, bottom: bordeFino, left: bordeFino, right: bordeFino };
const estiloTitulo = {
  font: { bold: true, sz: 14, color: { rgb: "FFFFFF" } },
  fill: { fgColor: { rgb: COLOR_MARCA } },
  alignment: { horizontal: "center", vertical: "center" },
};
const estiloEncabezado = {
  font: { bold: true, sz: 11, color: { rgb: "1A3A4A" } },
  fill: { fgColor: { rgb: "D6F4F8" } },
  alignment: { horizontal: "center", vertical: "center" },
  border: bordes,
};
const estiloCelda = { border: bordes, alignment: { vertical: "center" } };

export const descargarPlantillaCodigos = (codigos) => {
  const filas = [...codigos]
    .filter((c) => c.estado !== 2)
    .sort((a, b) => a.origen.localeCompare(b.origen) || a.codigo.localeCompare(b.codigo))
    .map((c) => [c.origen, c.motivo, c.codigo]);
  const blancos = Array.from({ length: RENGLONES_EN_BLANCO }, () => ["", "", ""]);
  const aoa = [
    [{ v: "Códigos de tiempo muerto", t: "s", s: estiloTitulo }, { v: "", s: estiloTitulo }, { v: "", s: estiloTitulo }],
    COLUMNAS.map((c) => ({ v: c.titulo, t: "s", s: estiloEncabezado })),
    ...[...filas, ...blancos].map((fila) => fila.map((v) => ({ v, t: "s", s: estiloCelda }))),
  ];
  const hoja = XLSXStyle.utils.aoa_to_sheet(aoa);
  hoja["!cols"] = COLUMNAS.map((c) => ({ wch: c.ancho }));
  hoja["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } }];
  const libro = XLSXStyle.utils.book_new();
  XLSXStyle.utils.book_append_sheet(libro, hoja, "Codigos");
  XLSXStyle.writeFile(libro, "Codigos_Tiempo_Muerto.xlsx");
};

const normalizar = (texto) =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

export const filasCodigosDesdeHoja = (XLSX, hoja) => {
  const crudas = XLSX.utils.sheet_to_json(hoja, { header: 1, defval: "" });
  const indiceEncabezado = crudas.findIndex((fila) => {
    const encabezados = fila.map(normalizar);
    return encabezados.includes("origen") && encabezados.includes("motivo") && encabezados.includes("codigo");
  });
  if (indiceEncabezado === -1) return null;
  const encabezados = crudas[indiceEncabezado].map(normalizar);
  const posicion = Object.fromEntries(COLUMNAS.map((c) => [c.clave, encabezados.indexOf(c.clave)]));
  return crudas
    .slice(indiceEncabezado + 1)
    .map((fila, indice) => ({
      fila: indiceEncabezado + indice + 2,
      origen: String(fila[posicion.origen] ?? "").trim(),
      motivo: String(fila[posicion.motivo] ?? "").trim(),
      codigo: String(fila[posicion.codigo] ?? "").trim(),
    }))
    .filter((fila) => fila.origen || fila.motivo || fila.codigo);
};
